<payee-popup title="Kredit feltöltése">
  <form [formGroup]="form">
    <div class="amount-form flex">
      <payee-form-field width="short">
        <input
          payee-input
          formControlName="amount"
        />
        @if (amount.invalid && amount.dirty) {
          <ng-container payee-error>
            <span>{{ amount.errors | json }}</span>
          </ng-container>
        }
      </payee-form-field>
      <payee-dropdown
        width="shorter"
        formControlName="currency_iso"
        [options]="currencyOptions"
      ></payee-dropdown>
    </div>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      Kredit feltöltése
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      width="max"
      color="white"
      mat-dialog-close
      [isBorderButton]="true"
      [disabled]="loading"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
